/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsArtistsItemsInner } from './RecordingManualChangesResponseFieldsArtistsItemsInner';
import {
    RecordingManualChangesResponseFieldsArtistsItemsInnerFromJSON,
    RecordingManualChangesResponseFieldsArtistsItemsInnerFromJSONTyped,
    RecordingManualChangesResponseFieldsArtistsItemsInnerToJSON,
} from './RecordingManualChangesResponseFieldsArtistsItemsInner';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsArtists
 */
export interface RecordingManualChangesResponseFieldsArtists {
    /**
     * 
     * @type {Array<RecordingManualChangesResponseFieldsArtistsItemsInner>}
     * @memberof RecordingManualChangesResponseFieldsArtists
     */
    items: Array<RecordingManualChangesResponseFieldsArtistsItemsInner>;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsArtists interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsArtists(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsArtistsFromJSON(json: any): RecordingManualChangesResponseFieldsArtists {
    return RecordingManualChangesResponseFieldsArtistsFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsArtistsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsArtists {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RecordingManualChangesResponseFieldsArtistsItemsInnerFromJSON)),
    };
}

export function RecordingManualChangesResponseFieldsArtistsToJSON(value?: RecordingManualChangesResponseFieldsArtists | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(RecordingManualChangesResponseFieldsArtistsItemsInnerToJSON)),
    };
}

